import { createSlice } from '@reduxjs/toolkit';
import {
  createNews,
  deleteNews,
  getNews,
  getTestimonials,
  getUsersUpdates,
  getVideoStories,
} from './operations';

const initialState = {
  newsList: [],
  updatesList: [],
  testimonials: [],
  videoStories: [],
  newsListPagination: {},
  updatesPagination: {},
  testimonialsPagination: {},
  videoStoriesPagination: {},
};

export const sliceNews = createSlice({
  name: 'News',
  initialState,

  extraReducers: builder => {
    builder
      .addCase(getUsersUpdates.fulfilled, (state, { payload: userData }) => {
        console.log(userData);

        const { news, ...pagination } = userData;
        state.updatesList = news;
        state.updatesPagination = pagination;
      })
      .addCase(getTestimonials.fulfilled, (state, { payload: userData }) => {
        const { news, ...pagination } = userData;
        state.testimonials = news;
        state.testimonialsPagination = pagination;
      })
      .addCase(getNews.fulfilled, (state, { payload: userData }) => {
        const { news, ...pagination } = userData;
        state.newsList = news;
        state.newsListPagination = pagination;
      })
      .addCase(getVideoStories.fulfilled, (state, { payload: userData }) => {
        const { news, ...pagination } = userData;
        state.videoStories = news;
        state.videoStoriesPagination = pagination;
      })
      .addCase(createNews.fulfilled, (state, { payload: userData }) => {
        switch (userData.type) {
          case 'news':
            state.newsList.push(userData);
            break;
          case 'testimonials':
            state.testimonials.push(userData);
            break;
          case 'updates':
            state.updatesList.push(userData);
            break;
          case 'video stories':
            state.videoStories.push(userData);
            break;
        }
      })
      .addCase(deleteNews.fulfilled, (state, { payload: userData }) => {
        console.log(userData);

        state.updatesList = state.updatesList.filter(el => {
          return el._id !== userData;
        });
      });
  },
});

export default sliceNews.reducer;
